import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui'; // 引入element ui
import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/css.css'; // 引入全局样式表
import '../static/remixIcon/remixicon.css' // 引入外部图标

Vue.use(ElementUI)
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
